import { render, staticRenderFns } from "./AdvBuyerSpaceInvitation.vue?vue&type=template&id=dba6cd66&"
import script from "./AdvBuyerSpaceInvitation.vue?vue&type=script&lang=js&"
export * from "./AdvBuyerSpaceInvitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports